import { createSlotRecipe } from './runtime';

const filterChipConfig = {"name":"filterChip","className":"filter-chip","slots":["root","icon","label","value","remove"]}

export const filterChip = /* @__PURE__ */ createSlotRecipe(filterChipConfig)